function u() {
}
function f(n, t) {
  if (e(n)) {
    const o = i(t) ? t() : t;
    return n(o);
  }
  return n;
}
function e(n) {
  return typeof n == "function";
}
function i(n) {
  return typeof n == "function";
}
function c(n, t) {
  return Object.prototype.hasOwnProperty.call(n, t);
}
function s() {
  for (var n = arguments.length, t = new Array(n), o = 0; o < n; o++)
    t[o] = arguments[o];
  return function() {
    for (const r of t)
      typeof r == "function" && r(...arguments);
  };
}
function a(n) {
  if (window.queueMicrotask)
    return window.queueMicrotask(n);
  Promise.resolve().then(n);
}
export {
  f as applyState,
  s as chain,
  c as hasOwnProperty,
  u as noop,
  a as queueMicrotask
};
//# sourceMappingURL=misc.js.map
